import { ApplicationConfig, importProvidersFrom, isDevMode } from '@angular/core';
import { provideRouter } from '@angular/router';

import { routes } from './app.routes';
import { Action, provideStore } from '@ngrx/store';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpClient, provideHttpClient } from '@angular/common/http';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { AppState, reducers } from './core/store/core.state';
import { UserEffects } from './user/store/user.effects';
import { provideEffects } from '@ngrx/effects';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideStoreDevtools } from '@ngrx/store-devtools';
import { AuthenticationService } from './shared/services/authentication.service';
import { ToastService } from './shared/services/toast.service';
import { provideToastr } from 'ngx-toastr';
import { TranslocoHttpLoader } from './transloco-loader';
import { provideTransloco } from '@jsverse/transloco';
import { provideTranslocoLocale } from '@jsverse/transloco-locale';
import { CourseEffects } from './course/store/course.effects';
import { CourseService } from './course/services/course.service';
import { DigitalProductEffects } from './digitalProduct/store/digitalProduct.effects';
import { DigitalProductService } from './digitalProduct/services/digitalProduct.service';
import { SubscriptionEffects } from './subscription/store/subscription.effects';
import { SubscriptionService } from './subscription/services/subscription.service';

// AoT requires an exported function for factories
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes),
    provideHttpClient(),
    importProvidersFrom(
      TranslateModule.forRoot({
      loader: {
          provide: TranslateLoader,
          useFactory: HttpLoaderFactory,
          deps: [HttpClient],
      }
    })
  ),
    provideStore<AppState, Action>(reducers),
    provideEffects(
      [
        UserEffects,
        CourseEffects,
        DigitalProductEffects,
        SubscriptionEffects
      ]),
    provideStoreDevtools(),
    AuthenticationService,
    ToastService,
    CourseService,
    DigitalProductService,
    SubscriptionService,
    provideToastr(),
    provideAnimations(),
    provideTransloco({
        config: {
          availableLangs: ['en-US', 'pt-PT', 'pt-BR'],
          defaultLang: 'en-US',
          // Remove this option if your application doesn't support changing language in runtime.
          reRenderOnLangChange: true,
          prodMode: !isDevMode(),
        },
        loader: TranslocoHttpLoader
      }),
      provideTranslocoLocale(),
      provideTransloco({
          config: {
            availableLangs: ['en', 'es', 'pt-BR', 'pt-PT'],
            defaultLang: 'en',
            // Remove this option if your application doesn't support changing language in runtime.
            reRenderOnLangChange: true,
            prodMode: !isDevMode(),
          },
          loader: TranslocoHttpLoader
        })
  ]
};

